import {Component, ViewEncapsulation, Input, HostListener, ViewChild} from '@angular/core';
import {MenuComponent} from "../menu/menu.component";
import {Location} from "@angular/common";
import {DisqusComponent} from "../comments/disqus.component";
require('./sticky-header.component.scss');

@Component({
  templateUrl: './sticky-header.component.html',
  selector: 'stickyHeader',
  styleUrls: [ './sticky-header.component.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class StickyHeaderComponent {

  @Input('url') url: string;
  @Input() title: string;
  @Input() twitterText: string;
  @Input() ogTitle: string;
  @Input() ogDescription: string;

  @ViewChild('disqus') protected disqus: DisqusComponent;

  constructor(protected location: Location){
  }

  public isVisible: boolean = false;

  @HostListener("window:scroll", ["$event"])
  public onScroll(event: any): void
  {
      this.isVisible = (window.pageYOffset > 200) || MenuComponent.isMenuOpened;
  }

  public showComments(event) {
    this.disqus.determineVisibility();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/sticky-header/sticky-header.component.ts